import { request, success, failure, LEAVES_REQUEST, ATTENDANCE } from './utilities';
import { getAllLeavesType, getAllLeavesRequest, updateLeaveRequestStatus } from '../api';
import { PostRequest } from '../api/genericApiCalls';

export function getLeavesType() {
    return (disapatch) => {
        disapatch(request(LEAVES_REQUEST.GET_LEAVE_TYPE_REQUEST));
        getAllLeavesType().then(
            response => {
                if (response.data.status === 1) {
                    disapatch(success(LEAVES_REQUEST.GET_LEAVE_TYPE_SUCCESS, response.data.data))
                }
                else {
                    disapatch(failure(LEAVES_REQUEST.GET_LEAVE_TYPE_FAILURE, response.data.message))
                }
            },
            error => {
                disapatch(failure(LEAVES_REQUEST.GET_LEAVE_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}

